import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/about'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.AboutPageProps>()(Page.About)
